/**
 * Decorative coffee mug stain for authentic aged paper feel.
 * Position is randomized based on a seed value.
 */
export function CoffeeStain({ seed = 0 }: { seed?: number }) {
    // Use seed to deterministically choose position and rotation
    const positions = [
        { top: '15%', right: '8%', rotate: 12 },
        { top: '45%', right: '5%', rotate: -8 },
        { bottom: '20%', left: '6%', rotate: 25 },
        { top: '25%', left: '4%', rotate: -15 },
        { bottom: '35%', right: '10%', rotate: 5 },
    ];
    const pos = positions[seed % positions.length];

    return (
        <div
            className="absolute pointer-events-none"
            style={{
                ...pos,
                width: '80px',
                height: '80px',
                transform: `rotate(${pos.rotate}deg)`,
            }}
        >
            {/* Outer ring */}
            <div
                className="absolute inset-0 rounded-full"
                style={{
                    background: 'radial-gradient(circle at center, transparent 55%, rgba(139, 90, 43, 0.08) 60%, rgba(139, 90, 43, 0.12) 65%, rgba(139, 90, 43, 0.06) 75%, transparent 80%)',
                }}
            />
            {/* Inner stain - slightly offset for realism */}
            <div
                className="absolute rounded-full"
                style={{
                    top: '20%',
                    left: '15%',
                    width: '70%',
                    height: '70%',
                    background: 'radial-gradient(ellipse at 40% 40%, rgba(139, 90, 43, 0.06) 0%, transparent 70%)',
                }}
            />
            {/* Drip mark */}
            <div
                className="absolute"
                style={{
                    bottom: '-10px',
                    left: '40%',
                    width: '12px',
                    height: '20px',
                    background: 'linear-gradient(to bottom, rgba(139, 90, 43, 0.08) 0%, transparent 100%)',
                    borderRadius: '0 0 50% 50%',
                }}
            />
        </div>
    );
}
